export * from './avatar.pipe';
export * from './currency-format.pipe';
export * from './date-format.pipe';
export * from './field-format.pipe';
export * from './file-icon.pipe';
export * from './file-size.pipe';
export * from './format.pipe';
export * from './highlight-text.pipe';
export * from './interaction-icon.pipe';
export * from './lazy-array.pipe';
export * from './max-z-index.pipe';
export * from './name-initials.pipe';
export * from './note-icon.pipe';
export * from './number-format.pipe';
export * from './quarter-format.pipe';
export * from './regex-replace.pipe';
export * from './related-entry-icon.pipe';
export * from './relative-date.pipe';
export * from './replace.pipe';
export * from './resource-or-translate.pipe';
export * from './sum.pipe';
export * from './template.pipe';
export * from './text-truncate.pipe';
export * from './to-type.pipe';

import { AvatarPipe } from './avatar.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { FileIconPipe } from './file-icon.pipe';
import {
  DateFieldFormatPipe,
  NumberFieldFormatPipe,
} from './field-format.pipe';
import { FormatFileSizePipe } from './file-size.pipe';
import { FormatPipe } from './format.pipe';
import { HighlightTextPipe } from './highlight-text.pipe';
import { InteractionIconPipe } from './interaction-icon.pipe';
import { LazyArrayPipe } from './lazy-array.pipe';
import { MaxZIndexPipe } from './max-z-index.pipe';
import { NameInitialsPipe } from './name-initials.pipe';
import { NoteIconPipe } from './note-icon.pipe';
import { NumberFormatPipe } from './number-format.pipe';
import { QuarterFormatPipe } from './quarter-format.pipe';
import { RegexReplacePipe } from './regex-replace.pipe';
import { RelatedEntryIconPipe } from './related-entry-icon.pipe';
import { RelativeDatePipe } from './relative-date.pipe';
import { ReplacePipe } from './replace.pipe';
import { ResourceOrTranslatePipe } from './resource-or-translate.pipe';
import { SumPipe } from './sum.pipe';
import { TemplatePipe } from './template.pipe';
import { TextTruncatePipe } from './text-truncate.pipe';
import {
  ToArrayPipe,
  ToDatePipe,
  ToNumberPipe,
  ToStringPipe,
} from './to-type.pipe';

export const UI_PIPES = [
  AvatarPipe,
  CurrencyFormatPipe,
  DateFormatPipe,
  FileIconPipe,
  FormatFileSizePipe,
  FormatPipe,
  HighlightTextPipe,
  InteractionIconPipe,
  LazyArrayPipe,
  MaxZIndexPipe,
  NameInitialsPipe,
  NoteIconPipe,
  NumberFormatPipe,
  DateFieldFormatPipe,
  NumberFieldFormatPipe,
  QuarterFormatPipe,
  RegexReplacePipe,
  RelatedEntryIconPipe,
  RelativeDatePipe,
  ReplacePipe,
  ResourceOrTranslatePipe,
  SumPipe,
  TemplatePipe,
  TextTruncatePipe,
  ToDatePipe,
  ToNumberPipe,
  ToStringPipe,
  ToArrayPipe,
] as const;
